import { ActionHandler } from '../common/actions/core/action-handler';
import { Action } from '../common/actions/core/action';
import ActionDispatcherService from '../common/actions/core/action-dispatcher.service';
import {
  PackageThumbnail,
  ListeningPackageType,
  StudentPlanStatus,
  FamilyPlanTypes,
  ListeningPackageSegment
} from '../common/services/package/package.model';
import { PayByPaycellAction } from '../common/actions/pay-by-paycell.action';
import { OpenDoubleOptDialogAction } from '../components/double-opt-dialog/double-opt-dialog.action';
import { OpenDoubleOptTimeoutDialogAction } from '../components/double-opt-dialog/timeout/double-opt-timeout-dialog.action';
import { PayByBillAction } from '../common/actions/pay-by-bill.action';
import { Invoice } from './services/invoice.model';
import { BillInfoChangeAction } from './bill-info/bill-info.action';
import { OpenDoubleOptSuccessDialogAction } from '../components/double-opt-dialog/success/double-opt-success-dialog.action';
import { OpenDoubleOptErrorDialogAction } from '../components/double-opt-dialog/error/double-opt-error-dialog.action';
import { DistantSaleAction } from '../common/actions/distant-sale-action';
import { OpenDistantSalesAggreementAction } from './distant-sales-aggreement-dialog/distant-sales-aggreement-dialog.action';
import { ContractApproveAction } from '../common/actions/contract-approve-action';
import { PreInfoSaleAction } from '../common/actions/pre-info-action';
import { OpenPreInfoFormAction } from './pre-info-form-dialog/pre-info-form-dialog.action';
import { PaycellService } from './services/paycell.service';
import { BuySuccessAction } from './buy-success-dialog/buy-success-dialog.action';
import GlobalSpinnerService from '../common/services/spinner/global-spinner.service';
import { BillInfoAddDialogAction } from './bill-info/add/bill-info-add-dialog.action';
import GoogleAnalyticsService from '../common/services/analytics/google-analytics.service';
import { Ecommerce } from '../common/services/analytics/events/dimensions';
import FacebookPixelService from '../common/services/analytics/facebook-analytics.service';
import StudentPlanService from '../common/services/package/student.service';
import { OpenMasterBuyDialogAction } from '../family-plan/family-plan-master-buy-dialog/family-plan-master-buy-dialog.action';
import { AdjustEventService } from './services/adjust-event.service';
import { PayByMasterpassAction } from '../common/actions/pay-by-masterpass.action';
import { MasterpassService } from './services/masterpass.service';
import HttpService from '../common/services/http.service';
import { LanguageChangeAction } from '../common/actions/language.action';
import PackageService from '../common/services/package/package.service';


/* @ngInject */
export default class PaymentController implements ActionHandler {
  private packet: PackageThumbnail;
  private ecommerce:Ecommerce = new Ecommerce();
  private invoice: Invoice;
  private paymentMethodId: number;
  private cardId:string;
  private saleType: string;
  private paymentType: string;
  private promocode: string;

  constructor(
    private actionDispatcher: ActionDispatcherService,
    private paycellService: PaycellService,
    private globalSpinner: GlobalSpinnerService,
    private googleAnalytics: GoogleAnalyticsService,
    private $state,
    private $stateParams,
    private $location,
    private facebookAnalytics: FacebookPixelService,
    private studentPlanService: StudentPlanService,
    private adjustEventService: AdjustEventService,
    private masterpassService: MasterpassService,
    private httpService: HttpService,
    private packageService: PackageService
  ) {}

  public $onInit() {
    if (angular.isUndefined(this.packet)) {
      return;
    }
    if(this.packet.isStudent){
      this.studentPlanService.getUserStudentStatus().then(data => {
        if(data.studentPlanStatus != StudentPlanStatus.APPROVED)
          this.$state.go('myAccount');
      });
    }
    if (!!this.$stateParams.promocode) {
      sessionStorage.setItem('promocode', this.$stateParams.promocode);
      this.$location.search('promocode', null);
    } else if (!!sessionStorage.getItem('promocode')) {
      this.promocode = sessionStorage.getItem('promocode');
      sessionStorage.removeItem('promocode');
    }
  }

  public isPaycellPackage() {
    return this.packet.type === ListeningPackageType.CREDITCARD;
  }

  public $postLink() {
    this.actionDispatcher.register(this);
    this.googleAnalytics.writeVirtualPages({
      event: 'GAVirtual',
      virtualPageTitle: 'Fizy Premium Satin Al - ' + this.packet.name,
      virtualPageURL: '/buy' + this.packet.id
    });
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
  }

  public handle(action: Action) {
    if(action instanceof LanguageChangeAction && action.reloadAuthData){
      this.globalSpinner.startIfNotActivated();
      this.packageService.getUserListeningPackagesNoCache().then(packages => {
        for (var i = 0; i < packages.offerablePackages.length; i++) {
          if (packages.offerablePackages[i].offerId === this.packet.id) {
            this.packet = this.packageService.convertListeningPackage(packages.offerablePackages[i]);
          }
        }
        this.globalSpinner.stop();
      });
    }
    
    if (action instanceof PayByPaycellAction) {
      this.paymentMethodId = action.paymentMethodId;
      this.cardId = action.cardId;
      this.globalSpinner.startIfNotActivated(true);
      this.paycellService
        .validatePasswordAndBuy(this.packet, this.paymentMethodId, this.cardId)
        .then((data) => {
          this.googleAnalytics.sendGAEvent('Success',this.packet);
          this.facebookAnalytics.sendFBEvent('PremiumSatıs',null);
          const event = this.getAdjustKey();
                   
          this.adjustEventService.postEvent(event, this.packet.priceUnit, this.packet.price);
          if (this.isFamilySegment(this.packet.packageSegment)) {
            this.actionDispatcher.dispatch(new OpenMasterBuyDialogAction(this.packet.family));
          }
          else{
            this.actionDispatcher.dispatch(new BuySuccessAction(this.packet.packageSegment));
          }
          this.httpService.evictResultCache('paycellPackagePaymentMethod', true);
          this.httpService.evictResultCache('paycellPaymentMethods', true);
        })
        .catch(error => {
          this.googleAnalytics.sendGAEvent('Failure',this.packet,error);
        })
        .finally(() => this.globalSpinner.stop(true));

    }

    if (action instanceof PayByBillAction) {
      this.paymentMethodId = null;
      this.cardId = null;
      this.openDoubleOpt();
    }

    if (action instanceof BillInfoChangeAction) {
      this.invoice = action.invoice;
    }

    if (action instanceof DistantSaleAction) {
      this.saleType = action.type;
      this.paymentType = action.paymentType;
      this.openDistantSale();
    }

    if (action instanceof PreInfoSaleAction) {
      this.paymentType = action.paymentType;
      this.openPreInfo();
    }

    if (action instanceof BillInfoAddDialogAction) {
      var names = ['#firstName', '#lastName', '#e-mail'];
      for (var i = 0; i < names.length; i++) {
        var elem = document.querySelector(names[i]) as HTMLElement;
        if (elem.getAttribute('aria-invalid') === 'true') {
          elem.focus();
          break;
        }
      }
    }

    if(action instanceof PayByMasterpassAction) {
      this.globalSpinner.startIfNotActivated(true);
      this.masterpassService.startSubscription(this.packet, action.card.Name, action.card.UniqueId, action.promocode).then(response => {
        this.googleAnalytics.sendGAEvent('Success',this.packet);
        this.facebookAnalytics.sendFBEvent('PremiumSatıs',null);
        const event = this.getAdjustKey();
                 
        this.adjustEventService.postEvent(event, this.packet.priceUnit, this.packet.price);
        if (this.isFamilySegment(this.packet.packageSegment)) {
          this.actionDispatcher.dispatch(new OpenMasterBuyDialogAction(this.packet.family));
        }
        else{
          this.actionDispatcher.dispatch(new BuySuccessAction(this.packet.packageSegment));
        }
        this.httpService.evictResultCache('masterPackagePaymentMethod', true);
        this.httpService.evictResultCache('masterPaymentMethods', true);
      }).catch(error => {
        this.googleAnalytics.sendGAEvent('Failure',this.packet,error);
        action.onError();
      })
      .finally(() => this.globalSpinner.stop(true));
    }
  }

  private getAdjustKey() {
    if(this.packet.family == FamilyPlanTypes.FAMILY)  {
      return 'e2oo7f';
    } else if(this.packet.family == FamilyPlanTypes.DUO) {
     return '4focid';
    } else if (this.packet.isStudent) {
      return 'gerguc';
    } else {
      return 'wnwa09';
    }   
  }

  private approveDistantSale() {
    this.actionDispatcher.dispatch(
      new ContractApproveAction({
        distantAggreement: true
      })
    );
  }

  private approvePreInfo() {
    this.actionDispatcher.dispatch(
      new ContractApproveAction({
        preInfoAggreement: true
      })
    );
  }

  public openDistantSale() {
    this.actionDispatcher.dispatch(
      new OpenDistantSalesAggreementAction(
        () => this.approveDistantSale(),
        this.saleType,
        this.packet.id,
        this.paymentType
      )
    );
  }

  public openPreInfo() {
    this.actionDispatcher.dispatch(
      new OpenPreInfoFormAction(() => this.approvePreInfo(), this.packet.id, this.paymentType)
    );
  }

  private onSuccess(packet: PackageThumbnail) {
    this.googleAnalytics.sendGAEvent('Success', this.packet, '', 'bill');
    this.facebookAnalytics.sendFBEvent('PremiumSatıs',null);
    const event = this.getAdjustKey();
    this.adjustEventService.postEvent(event, this.packet.priceUnit, this.packet.price);
    if (this.isFamilySegment(this.packet.packageSegment)) {
      this.actionDispatcher.dispatch(new OpenMasterBuyDialogAction(this.packet.family));
    }
    else{
      this.actionDispatcher.dispatch(new OpenDoubleOptSuccessDialogAction(packet.packageSegment));
    }
  }

  private onTimeOut() {
    this.actionDispatcher.dispatch(
      new OpenDoubleOptTimeoutDialogAction(() => this.openDoubleOpt())
    );
  }

  private onError(error: any) {
    this.googleAnalytics.sendGAEvent('Failure',this.packet,error, 'bill');
    this.actionDispatcher.dispatch(new OpenDoubleOptErrorDialogAction());

  }

  private openDoubleOpt() {
    this.actionDispatcher.dispatch(
      new OpenDoubleOptDialogAction(
        packet => this.onSuccess(packet),
        error => this.onError(error),
        () => this.onTimeOut(),
        this.packet,
        this.paymentMethodId,
        this.cardId
      )
    );
  }

  private isFamilySegment(segment: ListeningPackageSegment) {
    return (
      segment === ListeningPackageSegment.AILE ||
      segment === ListeningPackageSegment.FAMILY ||
      segment === ListeningPackageSegment.DUO
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/buy/buy.controller.ts